import { Injectable, inject } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FilterSelectItem } from '../../../components/checkbox-facette/checkbox-liste/filterSelectItem';
import { AggregationKey } from '../../../model/aggregations';
import { FacettenService } from '../facetten.service';
import { BeginnterminUrlService } from './beginnterminurl.service';

@Injectable({
  providedIn: 'root'
})
export class BeginnterminService extends FacettenService {
  constructor() {
    const beginnterminUrlService = inject(BeginnterminUrlService);

    super(beginnterminUrlService, AggregationKey.Beginntermin, []);
  }

  /**
   * Sonderbehandlung, da die Beginntermin-Aggregation eine abweichende Struktur hat,
   * welche die dynamische Bezeichnung der Optionen gleich mitliefert.
   */
  override getSelectItems$(): Observable<FilterSelectItem[]> {
    return combineLatest([
      this.filterAggregations$,
      this.facettenUrlService.selectedOptionIds$
    ]).pipe(
      map(([{ BEGINNTERMIN }, selektierteBeginntermine]) =>
        Object.entries(BEGINNTERMIN).map(([_, option]) => ({
          key: option.id.toString(),
          label: option.name,
          ariaLabel: option.name,
          selected: selektierteBeginntermine.includes(option.id.toString()),
          treffer: option.anzahl,
          active: option.anzahl > 0
        }))
      )
    );
  }
}
